import { QuoteDTO, QuoteItemDTO } from '@setvi/shared/services/react-query';
import { getItemId } from '../utils/quote-helpers';
import { useQuoteMutation } from './create-quote-mutation';

interface UpdateSectionVariables {
  sectionId: string;
  name: string;
  description?: string;
}

/**
 * Update section optimistically in quote
 */
const updateSectionOptimistically = (
  quote: QuoteDTO | undefined,
  { sectionId, name, description }: UpdateSectionVariables
): QuoteDTO | undefined => {
  if (!quote) return quote;

  const updateInList = (items: QuoteItemDTO[]): QuoteItemDTO[] =>
    items.map(item => {
      if (getItemId(item) === sectionId && item.type === 'section') {
        return {
          ...item,
          name,
          note: description || null
        };
      }

      return item;
    });

  return {
    ...quote,
    items: updateInList(quote.items)
  };
};

/**
 * Update section title and description with optimistic updates
 * Changes appear immediately in UI before API confirmation
 */
export const useUpdateSection = (quoteId: string) =>
  useQuoteMutation<UpdateSectionVariables>({
    quoteId,
    optimisticUpdate: updateSectionOptimistically
  });
